define('shared/remote/lead/enrolmentSurvey/consume',[
    'shared/lib/RSVP',
    '$'
],
function(RSVP, $) 
{
    'use strict';
    return function(options) {
        if (!options.leadId) return RSVP.reject('Missing LeadId');

        if (!options.academicQualifications && !options.studyFrequency) {
            return RSVP.resolve();
        }

        return new RSVP.Promise(function(resolve, reject) {
            var data = {
                lead_id: options.leadId
            };
            if (options.academicQualifications) data.academic_qualification = options.academicQualifications;
            if (options.studyFrequency) data.study_frequency = options.studyFrequency;
            var ajaxErrMsg = 'Failed to save member questionnaire due to a connection issue, please try again later.';
            return $.ajax({
                    url: '/online/landinghandler.ashx?lp=true&responsemode=json&update_only=true',
                    type: 'POST',
                    data: data,
                    dataType: 'json'
                }).then(
                    function (memberCreationQuestionnaireData) {
                        if(!memberCreationQuestionnaireData || !memberCreationQuestionnaireData.Success){
                            var err = new Error(ajaxErrMsg);
                            reject(err);
                        } else {
                            resolve();
                        }
                    },
                    function (reason) {
                        var err = reason || new Error(ajaxErrMsg);
                        reject(err);
                    }
                );
        });
    };
});
